module.exports = __webpack_public_path__ + "img/custcomService.e9d40b6c.jpg";